// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей): ОБЪЯСНЕНИЯ ЗАПИСЕЙ В ПОДСКАЗКАХ — транспорт record_help, кэш, «Edit description» (R2).
// Заказ (24.09, дословно): «Доработай тултип для всех предопределённых элементов, который бы объяснял что это, зачем это, как это можно использовать.
// И тоже для всех отчётов, дата-сорсов, задач, виджетов, списков в базе Delta Medical…»; «Я ожидаю, что при зажатом Alt и наведении на ссылочный
// элемент я буду видеть его tooltip; например, … ячейка 94:2 это мера, и я хочу видеть его [объяснение]… проверь, что у всех мер есть tooltip с описанием».
//
// Как устроено:
// - бэк (R1, common_modules/record_help.py): executeBackendMethod method 'record_help', params { items: [{ id, segment }] (≤ 500), lang } →
//   { record_help: { '<segment>|<id>': { what, why, how, source: db | code | record, title, status? } | null } } — вызов как у catalog_titles (панель задач);
// - поставщик «пачкой» ядра (utils/uiHelp.js uiHelp_recordBatchProvider): подсказка не ждёт — первый показ без строк записи, ключ в очереди, одна пачка
//   на паузу 50 мс, не больше 500 ключей; ответ — кэш по ключу '<segment>|<id>' на языке интерфейса (null — «объяснения нет», повторно не спрашивается);
//   пришёл ответ — видимая подсказка перерисовывается сама (ядро: uiHelp_recordsReady / uiHelp_reshow). Строки записи — подписи About / Purpose /
//   How to use (ядро uiHelp_recordLabel), дописываются к подсказке, кнопки-действия остаются;
// - бэк без метода (ответ без record_help — dev02 до выкладки, бой): ОДНА строка в консоль, механизм выключен до перезагрузки, уведомлений нет;
// - выключатели: настройка базы fe.ux.recordHelp (по умолчанию вкл.; false — строк записей и запросов нет), fe.ux.recordHelpEdit (кнопка «Edit
//   description», вкл.); счётчики — window._recordHelp.stats (asks / hits — обращения подсказок и попадания кэша, requests / keys — запросы и ключи,
//   records / empty — ответы с текстом и без, errors / timeouts / noMethod, warms, edits / saves / editErrors, invalidations) и window._recordHelp.rec.stats
//   (ядро: asks / hits / empty / queued / batches / items / errors / stale);
// - «Edit description» (только админ — store.checkAccess access-admin, как панель задач): кнопка под строками записи (или «Add description», если
//   объяснения нет). IE 2026 09 25 / ODOO-… (замечание Игоря: многострочный диалог описания записи): клик открывает диалог components/RecordHelpDialog.vue —
//   многострочные What it is / Purpose / How to use на вкладках en / uk / ru (заполнение — loadAll: три вызова record_help), Save — saveItem
//   (record_help_save одним элементом со всеми полями, source manual; ответ — в кэш подсказок); прежний переход в форму элемента реестра RECORD-HELP
//   (widget_open widget-record) — вторичная ссылка диалога «Open in registry» (openForm) и запасной путь без диалога (openRegistry: объяснение из кода /
//   самой записи — элемент получает те же тексты языка интерфейса; элемент уже в базе — вызов без текстов только возвращает его id); window.prompt
//   в одну строку больше нет. Сохранение элемента в форме / списке — кэш объяснений цели сбрасывается (onSaved из store.saveRecord);
// - ссылочное поле формы (AttrLink) — подсказка статичная (v-wjTooltip), считается при отрисовке: строки берутся только из кэша, запрос уходит по
//   наведению (warm), пришёл ответ — поле перерисовывается ($forceUpdate) и видимая подсказка обновляется (reshowOwner → ядро, статичный владелец).
// Проба — tools/probes/recordhelp_check.mjs; итог и контракт — handoff-files/record-help-2026-09-24/R2-frontend.md.
import { t, getLanguage, LANGUAGE_IDS } from '@/i18n'
import { uiHelp_recordBatchProvider, uiHelp_addRecordProvider, uiHelp_recordLabel, uiHelp_reshow, uiHelp_recordsReady, uiHelp_enabled, UI_HELP_ROWS, escHtml } from './uiHelp.js'

export const RECORD_HELP_SEGMENT = 'RECORD-HELP'
const TEXT_FIELDS = ['what', 'why', 'how']
const BATCH_MAX = 500          // контракт record_help: ≤ 500 элементов на вызов
const BATCH_DELAY_MS = 50      // пауза сборки пачки
const RETRY_MS = 30000         // ошибка транспорта — ключи пачки не спрашиваются снова это время
const CALL_TIMEOUT_MS = 20000  // ответа нет — пачка считается ошибкой

const stats = { asks: 0, hits: 0, requests: 0, keys: 0, answers: 0, records: 0, empty: 0, errors: 0, timeouts: 0, noMethod: 0, warms: 0, edits: 0, saves: 0, editErrors: 0, invalidations: 0 }

const recordHelp = {
    store: null,
    rec: null,             // поставщик «пачкой» ядра: { provider, cache: Map('<segment>|<id>' → запись | null), stats, invalidate }
    off: '',               // 'no-method' — бэк без record_help: выключено до перезагрузки
    stats,
    _installed: false,
    _warned: false,
    _offProvider: null,
    _cacheLang: null,
    _waiters: new Map(),   // ключ → [cb] — ждут ответа (ссылочное поле формы: перерисовать статичную подсказку)

    install(store) {
        this.store = store
        if (this._installed) return
        this._installed = true
        this.rec = uiHelp_recordBatchProvider((items, lang) => this._fetch(items, lang), {
            register: false, name: 'records', delayMs: BATCH_DELAY_MS, max: BATCH_MAX, retryMs: RETRY_MS, lang: () => this.lang(),
        })
        // поставщик ядра: выключено — null (строк нет, запросов нет)
        this._offProvider = uiHelp_addRecordProvider((id, segment, ctx) => {
            if (!this.enabled() || !this.rec) return null
            this._cacheLang = this.lang()
            const e = this.rec.provider(id, segment, ctx)
            stats.asks++
            if (e) stats.hits++   // попадание в кэш с объяснением (null / в очереди — не попадание)
            return e
        }, 'records')
        if (typeof window !== 'undefined') window._recordHelp = this
    },
    lang() { try { return String(getLanguage() || 'en') } catch (e) { return 'en' } },
    setting(key, def) { try { const s = this.store; return s && typeof s.setting === 'function' ? s.setting(key, def) : def } catch (e) { return def } },
    enabled() { return !this.off && !!this.rec && this.setting('fe.ux.recordHelp', true) !== false && uiHelp_enabled() },
    isAdmin() { try { return !!(this.store && this.store.checkAccess && this.store.checkAccess({ viewAccess: 'access-admin' })) } catch (e) { return false } },
    canEdit() { return this.enabled() && this.setting('fe.ux.recordHelpEdit', true) !== false && this.isAdmin() },
    keyOf(id, segment) { return `${segment || ''}|${id}` },
    // поле текста на языке интерфейса: en — основное (what), uk / ru — с суффиксом (what_uk); контракт record_help_save
    field(f, lang) { return (lang && lang !== 'en') ? `${f}_${lang}` : f },

    // ---- транспорт: одна пачка → один executeBackendMethod record_help ----
    _fetch(items, lang) {
        const store = this.store
        if (!store || this.off) return Promise.resolve({})
        stats.requests++
        stats.keys += items.length
        return new Promise((resolve, reject) => {
            let done = false
            const fin = (ok, v) => { if (done) return; done = true; clearTimeout(tm); if (ok) resolve(v); else { this._failed(items); reject(v) } }
            const tm = setTimeout(() => { stats.timeouts++; fin(false, new Error('record_help: no answer')) }, CALL_TIMEOUT_MS)
            try {
                store.executeBackendMethod({}, { method: 'record_help', params: { items, lang } }, (answer) => {
                    const map = answer && answer.record_help
                    if (map && typeof map === 'object') {
                        stats.answers++
                        let n = 0
                        for (const it of items) { if (map[this.keyOf(it.id, it.segment)]) n++ }
                        stats.records += n
                        stats.empty += items.length - n
                        fin(true, map)
                        // после того, как ядро положило ответ в кэш (его обработчик — микрозадача, таймер — позже): ждущие поля, «Add description»
                        setTimeout(() => this._answered(items), 0)
                        return
                    }
                    const note = answer && answer.notification
                    if (note && ['error', 'critical'].includes(note.status)) { stats.errors++; fin(false, new Error(String(note.text || 'record_help failed'))); return }
                    this._noMethod()
                    fin(true, {})
                })
            } catch (e) { stats.errors++; fin(false, e) }
        })
    },
    // бэк без метода: одна строка в консоль, механизм выключен до перезагрузки (кэш снят), уведомлений нет
    _noMethod() {
        stats.noMethod++
        this.off = 'no-method'
        try { if (this.rec) this.rec.cache.clear() } catch (e) { /* кэша нет */ }
        this._waiters.clear()
        if (!this._warned) {
            this._warned = true
            try { console.info('recordHelp: the backend has no record_help method — record explanations in tooltips are off until the page is reloaded') } catch (e) { /* без консоли */ }
        }
    },
    _failed(items) { for (const it of items || []) this._waiters.delete(this.keyOf(it.id, it.segment)) },
    // ответ пачки в кэше: ждущие (поле формы) перерисовываются; у записей без объяснения админ видит «Add description» — ядро такие подсказки не
    // перерисовывает (повторный показ — только для записей с текстом), поэтому здесь
    _answered(items) {
        let nulls = 0
        for (const it of items || []) {
            const k = this.keyOf(it.id, it.segment)
            if (this.rec && this.rec.cache.has(k) && !this.rec.cache.get(k)) nulls++
            const ws = this._waiters.get(k)
            if (ws) { this._waiters.delete(k); for (const fn of ws) { try { fn() } catch (e) { /* поле ушло */ } } }
        }
        if (nulls && this.canEdit()) uiHelp_reshow()
    },

    // ---- чтение кэша (без запроса) ----
    // запись из кэша: объект | null («объяснения нет») | undefined (ещё не спрашивали / ждём / язык сменился)
    peek(id, segment) {
        if (!this.rec || id === undefined || id === null || id === '') return undefined
        if (this._cacheLang !== null && this._cacheLang !== this.lang()) return undefined
        const k = this.keyOf(String(id), String(segment || ''))
        return this.rec.cache.has(k) ? this.rec.cache.get(k) : undefined
    },
    // 'off' | 'pending' (не спрашивали / ждём) | 'none' (объяснения нет) | 'has'
    state(id, segment) {
        if (!this.enabled()) return 'off'
        const e = this.peek(id, segment)
        return e === undefined ? 'pending' : (e ? 'has' : 'none')
    },
    // запросить заранее (наведение на поле формы); cb — после ответа (кэш уже заполнен); true — запрос в очереди / в пути
    warm(id, segment, cb) {
        if (id === undefined || id === null || id === '' || !this.enabled()) return false
        const seg = String(segment || '')
        if (this.peek(id, seg) !== undefined) return false
        const k = this.keyOf(String(id), seg)
        if (typeof cb === 'function') { const ws = this._waiters.get(k) || []; if (ws.length < 20) ws.push(cb); this._waiters.set(k, ws) }
        stats.warms++
        this._cacheLang = this.lang()
        this.rec.provider(String(id), seg)
        return true
    },
    // строки записи ТОЛЬКО из кэша (статичная подсказка поля формы считается при отрисовке) — '<br>' + строки | ''
    cachedRowsHtml(id, segment) {
        if (!this.enabled()) return ''
        const e = this.peek(id, segment)
        if (!e || typeof e !== 'object') return ''
        const rows = []
        for (const f of UI_HELP_ROWS) {
            const v = e[f]
            if (v === undefined || v === null || String(v).trim() === '') continue
            rows.push(`<b class='tooltip-header'>${escHtml(uiHelp_recordLabel(f))}:</b> <b class='tooltip-text ui-help-text ui-help-record'> ${escHtml(String(v).trim())}</b>`)
        }
        return rows.length ? '<br>' + rows.join('<br>') : ''
    },
    // видимая подсказка владельца (или его потомка) — показать заново с новым контентом
    reshowOwner(el) {
        if (!el) return false
        return uiHelp_reshow((owner) => owner === el || (typeof el.contains === 'function' && el.contains(owner)))
    },

    // ---- «Edit description» (админ) ----
    // кнопка под строками записи: только когда ответ уже есть (у ждущих — появится при перерисовке по ответу); target: { id, segment, title }
    editHtml(target) {
        if (!target || target.id === undefined || target.id === null || target.id === '' || !this.canEdit()) return ''
        // IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице) · p206b: временная страница (плитка «+» рейла) — записи нет, описывать нечего
        try { const s = this.store; if (String(target.segment || '') === 'PAGE' && s && typeof s.page_isTemp === 'function' && s.tempPagePlus_on?.() && s.page_isTemp(s.activeWORKSPACE?.workspace, target.id)) return '' } catch (e) { /* без стора */ }
        const st = this.state(target.id, target.segment)
        if (st !== 'has' && st !== 'none') return ''
        const has = st === 'has'
        const label = has ? t('Edit description') : t('Add description')
        // IE 2026 09 25 / ODOO-… (замечание Игоря: многострочный диалог описания записи): кнопка открывает диалог правки (RecordHelpDialog)
        const title = has ? t('Edit the explanation of this record: What it is, Purpose and How to use in English, Ukrainian and Russian (administrators).')
            : t('Write an explanation of this record: What it is, Purpose and How to use in English, Ukrainian and Russian; it is kept in the «Record help» registry (administrators).')
        const arg = { kind: 'recordhelp', id: String(target.id), segment: String(target.segment || ''), title: String(target.title || '') }
        return `<div class="tip-help-actions"><button type="button" tabindex="-1" class="tip-btn tip-btn-edithelp" data-tip-act="edithelp" data-help-state="${st}" data-tip-arg="${escHtml(JSON.stringify(arg))}" title="${escHtml(title)}"><i class="pi pi-pencil"></i><span>${escHtml(label)}</span></button></div>`
    },
    _call(method, params, ms = CALL_TIMEOUT_MS) {
        const store = this.store
        return new Promise((resolve) => {
            let done = false
            const fin = (v) => { if (!done) { done = true; clearTimeout(tm); resolve(v) } }
            const tm = setTimeout(() => fin({ ok: false, error: 'no answer from the server' }), ms)
            try {
                store.executeBackendMethod({}, { method, params }, (answer) => {
                    if (!answer || typeof answer !== 'object') { fin({ ok: false, error: 'empty answer' }); return }
                    if (method === 'record_help' && !(answer.record_help && typeof answer.record_help === 'object')) { fin({ ok: false, error: 'no-method', answer }); return }
                    if (method === 'record_help_save' && !Array.isArray(answer.items)) { fin({ ok: false, error: answer.message || (answer.status === 'error' ? 'error' : 'no-method'), answer }); return }
                    fin({ ok: true, answer })
                })
            } catch (e) { fin({ ok: false, error: String((e && e.message) || e) }) }
        })
    },
    _editFail(err, counted = false) {
        if (!counted) stats.editErrors++
        const text = err === 'no-method' ? t('Record help is not available on this server') : t('Could not open the explanation of the record: {error}', { error: String(err || '') })
        try { this.store.show_notification({ text, status: 'warning' }) } catch (e) { /* без уведомлений */ }
        return false
    },
    // IE 2026 09 25 / ODOO-… (замечание Игоря: многострочный диалог описания записи): «Edit description» / «Add description» открывает диалог components/RecordHelpDialog.vue (один на приложение,
    // регистрируется сам — recordHelp.dialog): многострочные What it is / Purpose / How to use на вкладках en / uk / ru, заполнение — loadAll (три вызова
    // record_help), Save — saveItem (record_help_save одним элементом со всеми полями, source manual). Прежний переход в форму элемента реестра — вторичная
    // ссылка диалога «Open in registry» (openForm) и запасной путь без диалога (openRegistry); window.prompt в одну строку больше нет
    dialog: null,
    async edit(arg = {}) {
        const store = this.store
        if (!store || !this.canEdit()) return false
        const id = String(arg.id ?? ''), segment = String(arg.segment ?? '')
        if (!id) return false
        stats.edits++
        const target = { id, segment, title: String(arg.title || '') }
        if (this.dialog && typeof this.dialog.open === 'function') return this.dialog.open(target) !== false
        return this.openRegistry(target)   // диалог не смонтирован — прежний переход
    },
    // тексты объяснения на языках langs — по вызову record_help на язык (lang en / uk / ru) → { ok, entries: { en: запись | null, uk, ru }, error };
    // свежий ответ на языке интерфейса — и в кэш подсказок
    async loadAll(id, segment, langs = LANGUAGE_IDS) {
        id = String(id ?? ''); segment = String(segment ?? '')
        if (!this.store || !id) return { ok: false, error: 'no record' }
        const key = this.keyOf(id, segment)
        const rs = await Promise.all(langs.map(lang => this._call('record_help', { items: [{ id, segment }], lang })))
        const bad = rs.find(r => !r.ok)
        if (bad) {
            const note = bad.answer && bad.answer.notification
            const text = note && ['error', 'critical'].includes(note.status) && note.text ? String(note.text) : ''
            return { ok: false, error: text || bad.error }
        }
        const entries = {}
        langs.forEach((lang, i) => { const e = rs[i].answer.record_help[key]; entries[lang] = (e && typeof e === 'object') ? e : null })
        const cur = this.lang()
        if (this.rec && Object.prototype.hasOwnProperty.call(entries, cur)) { this.rec.cache.set(key, entries[cur]); this._cacheLang = cur }
        return { ok: true, entries }
    },
    // IE 2026 11 03 / ODOO-350881 (карточка помощи окна, utils/helpCard.js): объяснения нескольких записей ОДНИМ вызовом record_help на языке интерфейса — мимо
    // очереди подсказок (карточка ждёт ответа) и без записи в их кэш (подсказка по Alt — как была) → { ok, map: { '<segment>|<id>': запись | null }, error }
    async describe(items) {
        if (!this.store || !Array.isArray(items) || !items.length) return { ok: false, map: {}, error: 'no items' }
        const r = await this._call('record_help', { items, lang: this.lang() })
        return r.ok ? { ok: true, map: r.answer.record_help } : { ok: false, map: {}, error: r.error }
    },
    // запись одного элемента реестра: item — { id, segment, source?, what, why, how, what_uk, …, how_ru } (переданное пустое снимается, непереданное
    // остаётся — контракт R1) → { ok, res (элемент ответа: result saved | archived | unchanged, id), answer, nothing («пустое на несуществующем» —
    // записывать нечего), error }; ответ — в кэш подсказок языка интерфейса, прочие ключи той же записи сброшены, видимая подсказка перерисовывается
    async saveItem(item) {
        if (!this.store || !this.canEdit()) return { ok: false, error: 'admin rights required' }
        const lang = this.lang()
        const r = await this._call('record_help_save', { items: [item], lang })
        if (!r.ok) { stats.editErrors++; return { ok: false, error: r.error } }
        const res = Array.isArray(r.answer.items) ? r.answer.items[0] : null
        if (!res || !['saved', 'archived', 'unchanged'].includes(res.result)) { stats.editErrors++; return { ok: false, error: (res && res.message) || r.answer.message || 'no answer for the item' } }
        const nothing = res.result === 'unchanged' && !!res.message
        if (!nothing) stats.saves++
        this._applySaved(String(item.id), String(item.segment ?? ''), r.answer.record_help, lang)
        return { ok: true, res, answer: r.answer, nothing }
    },
    _applySaved(id, segment, map, lang) {
        const key = this.keyOf(id, segment)
        this.invalidateId(id)
        if (map && typeof map === 'object' && Object.prototype.hasOwnProperty.call(map, key) && this.rec && lang === this.lang()) { this.rec.cache.set(key, map[key] || null); this._cacheLang = lang }
        try { uiHelp_recordsReady([{ id, segment }]) } catch (e) { /* подсказки нет */ }
    },
    // форма элемента реестра RECORD-HELP — штатная форма записи (widget_open widget-record), как «Open record» подсказки
    openForm(rhId) {
        const store = this.store
        if (!store || !rhId) return false
        const vueObj = store.activeWIDGET?.vueObj || store.App
        store.executeStoreMethod(vueObj, { action_name: 'action-front-2026-09-24-record-help-edit', command: 'widget_open', widget: 'widget-record', _activate: true, open_in_children_widget: true,
            item: { id: String(rhId), segment: RECORD_HELP_SEGMENT } })
        return true
    },
    // прежний переход (запасной путь без диалога): объяснение не из базы — элемент получает ТЕ ЖЕ тексты языка интерфейса (видимое объяснение не
    // меняется), элемент уже в базе — вызов без текстов только возвращает его id; объяснения нет вовсе — открывать нечего (пустой элемент реестр не создаёт)
    async openRegistry(target) {
        if (!this.store || !this.canEdit()) return false
        const id = String(target?.id ?? ''), segment = String(target?.segment ?? '')
        if (!id) return false
        const lang = this.lang()
        const key = this.keyOf(id, segment)
        let entry = this.peek(id, segment)
        if (entry === undefined) {
            const r = await this._call('record_help', { items: [{ id, segment }], lang })
            if (!r.ok) return this._editFail(r.error)
            entry = r.answer.record_help[key] || null
        }
        if (!entry) return this._editFail(t('there is no explanation yet — write it first'))
        const item = { id, segment }
        if (entry.source !== 'db') for (const f of TEXT_FIELDS) { const v = entry[f]; if (v !== undefined && v !== null && String(v).trim()) item[this.field(f, lang)] = String(v).trim() }
        const s = await this.saveItem(item)
        if (!s.ok) return this._editFail(s.error, true)
        if (s.nothing || !s.res.id) return this._editFail(t('there is no explanation yet — write it first'))
        return this.openForm(s.res.id)
    },

    // ---- сброс кэша ----
    // все ключи записи с этим id (сегмент в ключе бывает родительским: MEASURE|DOS — элемент SALES|DOS)
    invalidateId(id) {
        if (!this.rec || id === undefined || id === null || id === '') return 0
        const want = String(id)
        let n = 0
        for (const k of [...this.rec.cache.keys()]) { if (k.slice(k.indexOf('|') + 1) === want) { this.rec.cache.delete(k); n++ } }
        stats.invalidations += n
        return n
    },
    invalidate() { if (this.rec) this.rec.invalidate(); this._waiters.clear() },
    // сохранён элемент реестра (форма / список Record help) — объяснение его цели перечитывается при следующем показе
    onSaved(record) {
        let n = 0
        for (const r of (Array.isArray(record) ? record : [record])) {
            if (!r || r.segment !== RECORD_HELP_SEGMENT) continue
            const tid = r.doc && r.doc.target_id
            if (tid !== undefined && tid !== null && tid !== '') n += this.invalidateId(tid)
        }
        return n
    },
    // отладка: запись из кэша по ключу / (id, segment)
    get(id, segment) { return this.peek(id, segment) },
}

export default recordHelp
